import { Alert, Box, Link } from "@mui/material";
import { useState } from "react";
import useGlobalContext from "../../hooks/useGlobalContext";
import useSWR from "swr";
import localize from "../../common/localize";

export default function GeneralNotificationArea() {
  const {
    REQUEST_GENERAL_NOTIFICATION,
    getHeadersWithCorrespondingPagination,
    config,
    basicFilterData,
  } = useGlobalContext();

  const [expanded, setExpanded] = useState(false);

  const { data } = useSWR([
    REQUEST_GENERAL_NOTIFICATION,
    getHeadersWithCorrespondingPagination(config, 0, basicFilterData),
  ]);

  const showNotificationByType = (notification) => {
    switch (notification.Type) {
      case 0: // Info
        return (
          <Alert key={notification.Id} className="w-full my-2" severity="info">
            <label className="text-xs">{notification.Message}</label>
          </Alert>
        );
      case 1: // Warning
        return (
          <Alert
            key={notification.Id}
            className="w-full my-2"
            severity="warning"
          >
            <label className="text-xs">{notification.Message}</label>
          </Alert>
        );
      case 2: // Error
        return (
          <Alert key={notification.Id} className="w-full my-2" severity="error">
            <label className="text-xs">{notification.Message}</label>
          </Alert>
        );
      case 3: // Success
        return (
          <Alert
            key={notification.Id}
            className="w-full my-2"
            severity="success"
          >
            <label className="text-xs">{notification.Message}</label>
          </Alert>
        );
    }

    return <></>;
  };

  const notifications = data?.Data ?? [];

  if (notifications.length === 0) {
    return <Box className="w-full flex flex-col lateral_padding" />;
  }

  const visibleNotifications = expanded
    ? notifications
    : notifications.slice(0, 1);

  return (
    <Box className="w-full flex flex-col lateral_padding">
      <Box
        sx={{
          borderRadius: "10px",
          backgroundColor: "#ffffff",
          padding: "8px 16px",
          my: 1,
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
        }}
      >
        {visibleNotifications.map((notification) =>
          showNotificationByType(notification),
        )}

        {notifications.length > 1 && (
          <Box className="w-full flex justify-end">
            <Link
              component="button"
              type="button"
              underline="hover"
              onClick={() => setExpanded((prev) => !prev)}
              sx={{ fontSize: "0.75rem", color: "#10366e", cursor: "pointer" }}
            >
              {expanded ? localize.see_less : localize.see_more}
            </Link>
          </Box>
        )}
      </Box>
    </Box>
  );
}
